import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary mt-auto relative overflow-hidden isolate">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -bottom-16 -right-16 w-48 h-48 rounded-full bg-accent/8 blur-2xl" />
        <div className="absolute top-0 left-0 w-1.5 h-full bg-accent/30" />
      </div>
      <div className="container mx-auto px-4 py-6 relative z-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-primary-foreground/80">
          <p>
            Powered by <span className="font-semibold text-primary-foreground/80">TripVerse</span>
          </p>
          <div className="flex items-center gap-4">
            <Link 
              to="/privacy-policy" 
              className="hover:text-primary-foreground/80 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-of-service" 
              className="hover:text-primary-foreground/80 transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
